// import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Initialize Sentry error tracking BEFORE React renders
import { initSentry } from './lib/sentry';
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
